var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 10.7202L5.96005 2.98016C5.75121 2.8834 5.5215 2.84042 5.29181 2.85511C5.06212 2.86981 4.83975 2.94172 4.64495 3.06429C4.45015 3.18687 4.2891 3.35623 4.17647 3.55694C4.06383 3.75766 4.00318 3.98335 4.00005 4.21349V19.6868C3.9981 19.9231 4.05712 20.1558 4.17141 20.3626C4.28571 20.5693 4.4514 20.7431 4.65249 20.8671C4.85357 20.9911 5.08324 21.0611 5.31931 21.0704C5.55537 21.0797 5.78984 21.028 6.00005 20.9202L21.44 13.1802C21.6688 13.0653 21.861 12.8892 21.9954 12.6714C22.1298 12.4536 22.2009 12.2027 22.2009 11.9468C22.2009 11.6909 22.1298 11.44 21.9954 11.2222C21.861 11.0044 21.6688 10.8283 21.44 10.7135V10.7202Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.23ed68ce.svg";
export { ForwardRef as ReactComponent };